module.exports = __webpack_public_path__ + "img/171090.12769c7a.png";